export const manifest = (() => {
function __memo(fn) {
	let value;
	return () => value ??= (value = fn());
}

return {
	appDir: "_app",
	appPath: "_app",
	assets: new Set(["favicon.svg","robots.txt"]),
	mimeTypes: {".svg":"image/svg+xml",".txt":"text/plain"},
	_: {
		client: {start:"_app/immutable/entry/start.DQVJ-Ye9.js",app:"_app/immutable/entry/app.DDrbwSV-.js",imports:["_app/immutable/entry/start.DQVJ-Ye9.js","_app/immutable/chunks/BuPXQUT0.js","_app/immutable/chunks/BzfD0-ZS.js","_app/immutable/chunks/D3MuNBmD.js","_app/immutable/chunks/B5U7fqmF.js","_app/immutable/chunks/CXZTR9LB.js","_app/immutable/entry/app.DDrbwSV-.js","_app/immutable/chunks/D3MuNBmD.js","_app/immutable/chunks/B5U7fqmF.js","_app/immutable/chunks/DsnmJJEf.js","_app/immutable/chunks/BzfD0-ZS.js","_app/immutable/chunks/D3xBo6kT.js","_app/immutable/chunks/CgpIHpM6.js"],stylesheets:[],fonts:[],uses_env_dynamic_public:false},
		nodes: [
			__memo(() => import('./nodes/0.js')),
			__memo(() => import('./nodes/1.js')),
			__memo(() => import('./nodes/4.js'))
		],
		remotes: {
			
		},
		routes: [
			{
				id: "/sverdle",
				pattern: /^\/sverdle\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 2 },
				endpoint: null
			}
		],
		prerendered_routes: new Set(["/","/about","/sverdle/how-to-play"]),
		matchers: async () => {
			
			return {  };
		},
		server_assets: {}
	}
}
})();

export const prerendered = new Set(["/","/about","/sverdle/how-to-play"]);

export const base = "";